module.exports = __webpack_public_path__ + "about-us-b998e096/calendar-b2076b9c32c7225e928a1e0b9578bfbc.svg";